import { create } from "zustand";

export type ModalType =
  | "sidebar"
  | "payment-method"
  | "login-by-pass-modal"
  | "send-otp-modal"
  | "create-password-modal"
  | "terms-and-conditions"
  | "package-payment-method"
  | "military-related-services-modal"
  | "vehicle-payment-method"
  | "credit-score-verify-otp"
  | "back-cheques-verify-otp"
  | "electricity-bill-modal"
  | "gas-bill-modal"
  | "water-bill-modal"
  | null;

interface ModalState {
  openModal: ModalType;
  setOpenModal: (modal: ModalType) => void;
  closeModal: () => void;
}

export const useModalStore = create<ModalState>((set) => ({
  openModal: null,
  setOpenModal: (modal) => set({ openModal: modal }),
  closeModal: () => set({ openModal: null }),
}));
